import React from "react"
import PropTypes from "prop-types"

class CalendarInput extends React.Component {
  render() {
    const {onClick, value} = this.props
    return (
      <button className="transactions-history__calendar-button"
        onClick={onClick}>
        <span className="fa fa-calendar"/>&nbsp;
        {value}
      </button>
    )
  }
}

CalendarInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string
}

export default CalendarInput
